import Main from '../index'

export default {
  install (Vue, options = {}) {
    const Picker = Vue.extend(Main)
    function $exportList (dataVal) {
      const that = this
      const data = {
        ...options,
        exportVisible: true,
        ...dataVal,
        isPlugin: true
      }

      return new Promise((reslove) => {
        const vm = new Picker({
          propsData: data,
          created () {
            const destory = () => {
              this.$destroy()
              this.$el.remove()
            }

            this.$once('exportVisibleChange', (val) => {
              reslove(val)
              destory()
            })

            this.$once('goExportList', (val) => {
              that.$router.push({
                path: '/staffManagement/exportList?filestype=' + val,
                replace: true
              })
              destory()
            })
          }
        }).$mount()
        document.body.appendChild(vm.$el)
      })
    }

    Vue.prototype.$exportList = $exportList
  }
}
